﻿import { PlanProgressService } from './../../services/plan-progress.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { NotificationService } from './../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-plan-progress',
  templateUrl: './plan-progress.component.html',
  styleUrls: ['./plan-progress.component.scss']
})
export class PlanProgressComponent implements OnInit, OnChanges, OnDestroy {
  @Input() studentUserId: number;
  @Input() studentProgress: any;
  @Input() inList: boolean;
  @Input() selectedStudentPartnerId: any;
  @Input() heatmapId: number;
  planProgressLoader = false;
  progressGraph = [];
  studentPartnerId: number;
  heatMapOverviewUpdateSub: Subscription;
  userRole: string;

  constructor(
    private notificationService: NotificationService,
    public _commonDataSharedService: CommonDataSharedService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthenticationService: CommonAuthenticationService,
    private _planProgresService: PlanProgressService,
    private route: Router
  ) { }

  ngOnInit() {
    this.userRole = this._commonAuthenticationService.getModule();
    this.studentPartnerId = this.selectedStudentPartnerId || this._commonAuthenticationService.getPartnerId();
    this.heatMapOverviewUpdateSub = this._commonDataSharedService.heatMapOverviewUpdate.subscribe(() => {
      this.getStudentProgress();
    });
    this._commonDataSharedService.getProgression.subscribe(data => {

      this.heatmapId = +data;
      this.getStudentProgress();
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentUserId && changes.studentUserId.currentValue) {
      this.getStudentProgress();
      return;
    }
    if (changes.heatmapId && changes.heatmapId.currentValue) {
      this.getStudentProgress();
      return;
    }
    if (changes.studentProgress && changes.studentProgress.currentValue) {
      this.progressGraph = this._planProgresService.prepareGaugeData(changes.studentProgress.currentValue);
    }
  }

  getStudentProgress() {
    this.studentPartnerId = this.selectedStudentPartnerId || this._commonAuthenticationService.getPartnerId();
    this.planProgressLoader = !['coach', 'parent'].includes(this.userRole) ? true : false;

    const inputObject = {
      studentUserId: this.studentUserId,
      partnerId: this.studentPartnerId,
      HeatMapTypeId: this.heatmapId || 0
    };
    this._commonRequestResponseService.postWithHeader('shared/planprogress', inputObject, ['partnerId'])
      .subscribe(
        (data: any) => {
          this.planProgressLoader = false;

          if (this.route.url === '/coach/coachStudentDetail') {
            this._commonDataSharedService.loader.next(true);
          }
          if (data.category) {
            this.progressGraph = this._planProgresService.prepareGaugeData(data.category);
          }
        },
        () => {
          this.planProgressLoader = false;
          if (this.route.url === '/coach/coachStudentDetail') {
            this._commonDataSharedService.loader.next(true);
          }
          this.notificationService.show('error', 'Error while fetching student progress');
        })
  }

  ngOnDestroy() {
    this.heatMapOverviewUpdateSub.unsubscribe();
  }
}
